import React, { useEffect, useState } from "react";
import "./styles.scss";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: OptionProps[];
  defaultValueText: string;
  isWarning?: boolean;
  disabled?: boolean;
}

interface OptionProps {
  label: string;
  value: string;
}

const SimpleSelect: React.FC<SelectProps> = (props) => {
  const {
    options,
    defaultValueText,
    value,
    onChange,
    isWarning,
    disabled,
    ...rest
  } = props;
  const [waningInput, setWarningInput] = useState(false);

  useEffect(() => {
    setWarningInput(isWarning as boolean);

    setTimeout(() => {
      setWarningInput(false);
    }, 3000);
  }, [isWarning]);

  return (
    <select
      id="simple-select"
      className={`${waningInput ? "isWarning" : ""} ${
        disabled ? "disabled" : ""
      }`}
      value={value ?? ""}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    >
      <option value="" label={defaultValueText}></option>
      {options.map((option, index) => (
        <option key={index} id="option-default" value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SimpleSelect;
